import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "help",
  class: "helpOut"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Head, {
      isScroll: _ctx.isScroll,
      ref: "headSearch",
      showSearch: _ctx.showSearch
    }, null, 8, ["isScroll", "showSearch"]),
    _createVNode(_component_router_view)
  ], 512))
}